import { Injectable } from '@angular/core';
import { GLOBAL } from '../global';
import { UserSession } from '../domain/user-session';
import { ListaDeseos } from '../domain/lista-deseos';
import { Subscription, Observable } from 'rxjs';
import { GenericResponse } from '../domain/genericResponse';
import { ParteService } from './parte.service';
import { MatSnackBar } from '@angular/material';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Parte } from '../domain/parte';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class WishlistService {

  public listaDeseos: Array<ListaDeseos>;
  public subscription: Subscription;

  urlListaDeseo: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private snackBar: MatSnackBar,
    private parteService: ParteService,
    private authService: AuthService,
    public httpClient: HttpClient
  ) {
    this.urlListaDeseo = GLOBAL.URL_BASE + 'sicaListaDeseos';
    this.getListaDeseos();
  }

  /**
   * Retorna la información de la lista de deseos.
   * 
   * @author Camilo Delgado
   * @version 2018-11-20
   */
  getListaDeseos() {
    if (!this.listaDeseos) {
      let userSession = this.authService.getUser();
      if (userSession) {
        this.subscription = this.findAllSicaListaDeseoBySicaTerceroTercIdAndEstado(userSession.jti, GLOBAL.ESTADO_ACTIVO).subscribe(data => {
          let respuestaGenerica: GenericResponse = data;
          if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {
            let listaDeseos: ListaDeseos[] = respuestaGenerica.lista;
            let idsParte = [];
            for (let ld of listaDeseos) {
              idsParte.push(ld.partId);
            }
            this.getPartes(idsParte);
          } else {
            this.snackBar.open('¡Ha ocurrido un error al intentar cargar la lista de deseos! ' + respuestaGenerica.mensaje, '×', { panelClass: 'error', verticalPosition: 'top', duration: 8000 });
          }
        }, error => {
          this.snackBar.open('¡Ha ocurrido un error al intentar cargar la lista de deseos, por favor, intenta más tarde!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 8000 });
        }
        );
      } else {
        this.listaDeseos = new Array<ListaDeseos>();
      }
    }
    return this.listaDeseos;
  }

  private getPartes(idsParte: number[]) {
    this.subscription = this.parteService.getPartesByListId(idsParte).subscribe(data => {
      let respuestaGenerica: GenericResponse = data;
      if (respuestaGenerica.codigo === GLOBAL.HTTP_OK) {
        this.listaDeseos = respuestaGenerica.lista;
      } else {
        this.snackBar.open('¡Ha ocurrido un error al intentar cargar los productos de la lista de deseos! ' + respuestaGenerica.mensaje, '×', { panelClass: 'error', verticalPosition: 'top', duration: 8000 });
      }
    }, error => {
      this.snackBar.open('¡Ha ocurrido un error al intentar cargar los productos de la lista de deseos, por favor, intenta más tarde!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 8000 });
    }
    );
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-21
   * @param id
   * Guarda un nuevo item en la lista de deseos
   */
  saveWishListFromUser(listaDeseos: ListaDeseos): Observable<any> {
    return this.httpClient.post(this.urlListaDeseo + '/saveWishListFromUser/', listaDeseos, this.httpOptions);
  }
  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-21
   * @param id
   * Borra un item de la lista de deseos
   */
  deletePartInWhiteListFromUser(listaDeseos: ListaDeseos): Observable<any> {
    let index = this.listaDeseos.indexOf(listaDeseos);
    this.listaDeseos.splice(index, 1);
    return this.httpClient.post(this.urlListaDeseo + '/deletePartInWhiteListFromUser/', listaDeseos, this.httpOptions);
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-21
   * @param tercId
   * @param estado
   * Busca la lista de deseos de un usuario
   */
  findAllSicaListaDeseoBySicaTerceroTercIdAndEstado(tercId: number, estado: string): any {
    return this.httpClient.get(this.urlListaDeseo + '/findAllSicaListaDeseoBySicaTerceroTercIdAndEstado/' + tercId + '/' + estado);
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-21
   * @param id
   * Borrar todos los items de la lista de deseos del usuario
   */
  deleteAllPartFromUser(listaDeseos: ListaDeseos): Observable<any> {
    this.listaDeseos = new Array<ListaDeseos>();
    return this.httpClient.post(this.urlListaDeseo + '/deleteAllPartFromUser/', listaDeseos, this.httpOptions);
  }

  /**
   * Agrega un producto al carrito de compras.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-20
   * @param product Producto a agregar al carrito de compras.
   * @param isAuthenticate Es true si el usuario se encuentra autenticado, false de lo contrario.
   */
  public addToWishlist(product: Parte, tercId: number) {
    let message, status;
    let userSession = this.authService.getUser();

    if(!userSession){
      return;
    }

    if (this.listaDeseos.filter(item => item.partId == product.partId)[0]) {
      message = 'El Producto ' + product.nombre + ' ya se encuentra en la lista de deseos.';
      status = 'error';
    } else {
      let newListaDeseos: ListaDeseos = new ListaDeseos();
      newListaDeseos.partId = product.partId;
      newListaDeseos.tercId_SicaTercero = tercId;
      newListaDeseos.codigoParte = product.codigo;
      newListaDeseos.imagen = product.imagenes[0];
      newListaDeseos.estado = GLOBAL.ESTADO_ACTIVO;
      newListaDeseos.usuarioCreador = userSession.sub;
      newListaDeseos.fechaCreacion = new Date();

      this.subscription = this.saveWishListFromUser(newListaDeseos).subscribe((data: GenericResponse) => {
        if (data.codigo === GLOBAL.HTTP_OK) {
          this.listaDeseos.push(newListaDeseos);
          message = 'El Producto ' + product.nombre + ' ha sido añadido a la lista de deseos.';
          status = 'success';
          this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });
        } else {
          message = '¡Ha ocurrido un error al agregar a la lista de deseos! ' + data.mensaje;
          status = 'error';
          this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });
        }
      });

      message = 'El Producto ' + product.nombre + ' ha sido añadido al carrito.';
      status = 'success';
    }
    this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });
  }
}